import React, { useState, useEffect } from "react";
import SelectPaymentGateways from "./SelectPaymentGateways";
import ConfigurePaymentOptions from "./ConfigurePaymentOptions";

import ReviewConfigurations from "./ReviewConfigurations";
import { useAuth } from "../../../context/API_Client";

function AddGateways(props) {
  const { getAllPspConfigs, getAllPaymentMethods, supportedMethods } =
    useAuth();
  const [platformPspConfigs, setPlatformPspConfigs] = useState([]);
  const [platformPaymentMethods, setPlatformPaymentMethods] = useState([]);

  const [selectedPsps, setSelectedPsps] = useState([]);
  const [selectedEnv, setSelectedEnv] = useState("");
  useEffect(() => {
    setSelectedEnv(window.location.hostname.split(".")[0]);
  }, []);
  const handleSelectedPsps = (pspsToUpdate) => {
    setSelectedPsps(pspsToUpdate);
  };

  useEffect(() => {
    getAllPspConfigs((pspConfigs) => {
      setPlatformPspConfigs(pspConfigs);
    });

    getAllPaymentMethods((paymentMethods) => {
      setPlatformPaymentMethods(paymentMethods);
    });
  }, []);

  const getMethodsForPspAndType = (pspCode, type) => {
    return platformPspConfigs
      .filter(
        (pspConfig) =>
          pspConfig.pspCode === pspCode && platformPaymentMethods?.length > 0
      )
      .flatMap((pspConfig) =>
        pspConfig.paymentMethodIds.map((paymentMethodId) =>
          platformPaymentMethods.find(
            (pPaymentMethod) => pPaymentMethod.id === paymentMethodId
          )
        )
      )
      .filter((paymentMethodConfig) => paymentMethodConfig?.type === type);
  };

  const handleTabChange = () => {
    props.setValue(1);
  };

  const [pspSaved, setPspSaved] = useState(false);

  useEffect(() => {
    if (pspSaved && props && props.pspSelected?.length > 0) {
      handleTabChange();
    }
  }, [pspSaved, props.pspSelected]);

  const [filledCreds, setFilledCreds] = useState(false);

  const getSupportedMethods = () => {
    setFilledCreds(true);
  };

  const [preview, showPreview] = useState(false);

  useEffect(() => {
    if (
      filledCreds &&
      props?.payload[0]?.rules?.configs[0] &&
      props.value == 0
    ) {
      let Configs = {};
      let newfield;
      Object.keys(props?.payload[0]?.rules?.configs[0]).map((fieldName) => {
        if (fieldName !== "BusinessUnit") {
          newfield = {
            [fieldName]: props?.payload[0]?.rules?.configs[0][fieldName][1],
          };
          Configs = { ...Configs, ...newfield };
        }
      });
      const hasDemoValue = Object.values(Configs)?.some(
        (value) => value === "demo"
      );
      if (
        (selectedEnv === "sandbox-merchant" ||
          selectedEnv === "masquerade-sandbox-merchant") &&
        hasDemoValue
      ) {
        handleTabChange();
      } else {
        supportedMethods(
          props?.payload[0]?.rules?.configs[0]["BusinessUnit"][1],
          props?.payload[0]?.pspCode,
          {
            configs: Configs,
            currencyCodes: props?.payload[0]?.rules?.currencyCodes[0],
            countryCode: props?.payload[0]?.rules?.countryCode,
          },
          function (data) {
            props.setSupportedOptions(data);
            localStorage.setItem("paymentSwitchTabs", false);
            sessionStorage.setItem("storeCreds", JSON.stringify(props.storeCreds));
          },
          function (error) {
          
            props.setPspSelected([])
            
            // setPspSaved(true);
            setFilledCreds(false);
            props.setSupportedOptions(null);
            localStorage.setItem("paymentSwitchTabs", true);
          }
        );
      }
    }
  }, [filledCreds, props?.payload[0]?.rules?.configs[0]]);

  useEffect(() => {
    let cardItems = [],
      walletitems = [],
      bnplItems = [],
      netbankingItems = [],
      upiItems = [],
      cryptoItems = [],
      paynowItems = [],
      emiItems = [];
    let i = 0;
    if (props.value == 0 && filledCreds) {
      props.setCardSelects([]);
      props.setWalletSelects([]);
      props.setBnplSelects([]);
      props.setNetBankingSelects([]);
      props.setUpiSelects([]);
      props.setCryptoSelects([]);
      props.setPaynowSelects([]);
      props.setEmiSelects([]);
      props.setCountCards(0);
      props.setCountWallet(0);
      props.setCountBNPL(0);
      props.setCountNetBanking(0);
      props.setCountUPI(0);
      props.setCountCrypto(0);
      props.setCountPaynow(0);
      props.setCountEMI(0);

      for (i = 0; i < props.supportedOptions?.length; i++) {
        const obj = platformPaymentMethods.filter(
          (v) => v.id === props.supportedOptions[i].id
        );
        const items = [
          {
            title: obj[0]?.title,
            id: obj[0]?.id,
            type: obj[0]?.type,
            typeTitle: obj[0]?.typeTitle,
            logoUrl: obj[0]?.logoUrl,
          },
        ];

        if (obj[0]?.type === "Card") {
          cardItems = [...cardItems, ...items];
          props.setCardSelects(cardItems);
          props.setCountCards(cardItems.length);
        }
        if (obj[0]?.type === "Wallet") {
          walletitems = [...walletitems, ...items];
          props.setWalletSelects(walletitems);
          props.setCountWallet(walletitems.length);
        }
        if (obj[0]?.type === "BuyNowPayLater") {
          bnplItems = [...bnplItems, ...items];
          props.setBnplSelects(bnplItems);
          props.setCountBNPL(bnplItems.length);
        }
        if (obj[0]?.type === "NetBanking") {
          netbankingItems = [...netbankingItems, ...items];
          props.setNetBankingSelects(netbankingItems);
          props.setCountNetBanking(netbankingItems.length);
        }
        if (obj[0]?.type === "Upi") {
          upiItems = [...upiItems, ...items];
          props.setUpiSelects(upiItems);
          props.setCountUPI(upiItems.length);
        }
        if (obj[0]?.type === "Crypto") {
          cryptoItems = [...cryptoItems, ...items];
          props.setCryptoSelects(cryptoItems);
          props.setCountCrypto(cryptoItems.length);
        }
        if (obj[0]?.type === "Paynow") {
          paynowItems = [...paynowItems, ...items];
          props.setPaynowSelects(paynowItems);
          props.setCountPaynow(paynowItems.length);
        }
        if (obj[0]?.type === "Emi") {
          emiItems = [...emiItems, ...items];
          props.setEmiSelects(emiItems);
          props.setCountEMI(emiItems.length);
        }
      }
      if (i == props.supportedOptions?.length) {
        setPspSaved(true);
      }
    }
  }, [props.supportedOptions]);

  useEffect(() => {
    if (props.value == 0 && props.supportedOptions?.length > 0) {
      const data = [
        {
          pspCode: props?.payload[0]?.pspCode,
          cardSelects: props.cardSelects,
          walletSelects: props.walletSelects,
          bnplSelects: props.bnplSelects,
          NetBankingSelects: props.NetBankingSelects,
          upiSelects: props.upiSelects,
          cryptoSelects: props.cryptoSelects,
          PaynowSelects: props.PaynowSelects,
          emiSelects: props.emiSelects,

          clickedAllCards: true,
          clickedAllWallet: true,
          clickedAllBNPL: true,
          clickedAllNetBanking: true,
          clickedAllUPI: true,
          clickedAllCrypto: true,
          clickedAllPaynow: true,
          clickedAllEmi: true,
        },
      ];

      sessionStorage.setItem("storeOptions", JSON.stringify(data));
    }
  }, [
    props.supportedOptions,
    props.cardSelects,
    props.walletSelects,
    props.bnplSelects,
    props.NetBankingSelects,
    props.cryptoSelects,
    props.upiSelects,
    props.PaynowSelects,
    props.emiSelects,
  ]);

  useEffect(() => {
    if (props.value == 0 && props.supportedOptions?.length > 0) {
      const alldata = [
        {
          pspCode: props?.payload[0]?.pspCode,
          logoUrl: props?.payload[0]?.logoUrl,
          title: props?.payload[0]?.title,
          Cards: props.countCards,
          Wallet: props.countWallet,
          BuyNowPayLater: props.countBNPL,
          NetBanking: props.countNetBanking,
          UPI: props.countUPI,
          EMI: props.countEMI,
          Crypto: props.countCrypto,
          Paynow: props.countPaynow,
          cardSelects: props.cardSelects,
          walletSelects: props.walletSelects,
          bnplSelects: props.bnplSelects,
          NetBankingSelects: props.NetBankingSelects,
          upiSelects: props.upiSelects,
          cryptoSelects: props.cryptoSelects,
          PaynowSelects: props.PaynowSelects,
          emiSelects: props.emiSelects,
        },
      ];

      props.setPaymentOptions(alldata);

      let ids = [];

      props.cardSelects.map((obj) => ids.push(obj.id));
      props.walletSelects.map((obj) => ids.push(obj.id));
      props.bnplSelects.map((obj) => ids.push(obj.id));
      props.NetBankingSelects.map((obj) => ids.push(obj.id));
      props.upiSelects.map((obj) => ids.push(obj.id));
      props.cryptoSelects.map((obj) => ids.push(obj.id));
      props.PaynowSelects.map((obj) => ids.push(obj.id));
      props.emiSelects.map((obj) => ids.push(obj.id));

      const allIds = [
        {
          pspCode: props?.payload[0]?.pspCode,
          Ids: ids,
        },
      ];

      props.setPaymentOptionsIds(allIds);
    }
  }, [
    props.countCards,
    props.countWallet,
    props.countNetBanking,
    props.countBNPL,
    props.countUPI,
    props.countCrypto,
    props.countPaynow,
    props.cardSelects,
    props.walletSelects,
    props.bnplSelects,
    props.NetBankingSelects,
    props.cryptoSelects,
    props.upiSelects,
    props.PaynowSelects,
    props.emiSelects,
  ]);

  return (
    <div style={{ padding: "26px 0 0 0" }}>
      <section
        style={{
          border: "1.2px solid rgba(1, 1, 2, 0.12)",
          borderRadius: "16px",
          backgroundColor: "white",
        }}
      >
        {props && props.value === 0 && (
          <SelectPaymentGateways
            initialSelection={selectedPsps}
            selectedPspHandler={handleSelectedPsps}
            pspSelected={props.pspSelected}
            setPspSelected={props.setPspSelected}
            payload={props.payload}
            setPayload={props.setPayload}
            setValue={props.setValue}
            storeCreds={props.storeCreds}
            setStoreCreds={props.setStoreCreds}
            getMethodsForPspAndType={getMethodsForPspAndType}
            getSupportedMethods={getSupportedMethods}
            pspSaved={pspSaved}
            setPspSaved={setPspSaved}
          ></SelectPaymentGateways>
        )}

        {props &&
          props.value === 1 &&
          (preview || props.supportedOptions?.length > 0 ? (
            <ReviewConfigurations
              pspSelected={props.pspSelected}
              paymentOptions={props.paymentOptions}
              setPaymentOptions={props.setPaymentOptions}
              payload={props.payload}
              paymentOptionsIds={props.paymentOptionsIds}
              setPreview={showPreview}
              supportedOptions={props.supportedOptions}
              setValue={props.setValue}
            />
          ) : (
            <ConfigurePaymentOptions
              pspsToConfigure={props.pspSelected}
              preview={preview}
              showPreview={showPreview}
              paymentOptions={props.paymentOptions}
              setPaymentOptions={props.setPaymentOptions}
              paymentOptionsIds={props.paymentOptionsIds}
              setPaymentOptionsIds={props.setPaymentOptionsIds}
              storeOptions={props.storeOptions}
              setStoreOptions={props.setStoreOptions}
              getMethodsForPspAndType={getMethodsForPspAndType}
              supportedOptions={props.supportedOptions}
            ></ConfigurePaymentOptions>
          ))}
      </section>
    </div>
  );
}

export default AddGateways;
